export default __webpack_public_path__ + "static/media/bg-1.d925b95a.jpg";